<template>
<div>
    <v-snackbar
      timeout="1500"
      top
      style="text-align:center"
      color="#c56060"
      v-model="snackbar"
    >
        {{snackInfo}}
    </v-snackbar>
  <div class="wrapper">
      <div class="content">
          <div>{{userInfo}}的愿望是</div>
            <div>{{wish.name}}</div>
              <div>{{comment}}</div>
          </div>
      <div class="button-wrapper">
          <img src="../../assets/modal/confirm10.png" alt="" class="button"  @click="makeWish">
          <img src="../../assets/modal/confirm3.png" alt="" class="button"  @click="$emit('wishComplete-reselect')">
      </div>
      
  </div>
</div>
</template>

<script>
import * as api from '@/api/index'
export default {
    name: 'wishComplete',
    props: ["ownWish", "userInfo", "wishData"],
    data() {
        return {
            user: '',
            wish: '',
            comment: '',
            snackbar: false,
            snackInfo: ''
        }
    },
    mounted() {
        if (this.ownWish) {
            this.formatWish()
        }
    },
    methods: {
       formatWish() {
           console.log(this.wishData.desires, this.ownWish)
           const item = this.wishData.desires.find(item => {
               return item.id == this.ownWish.wishId
           })
           this.wish = item
           this.comment = this.ownWish.wishComment
       },
       showSnack(s) {
           this.snackbar = true
           this.snackInfo = s
       },
       async makeWish() {
           const res = await api.makeWish({
               activity_id: this.wishData.activity_id,
               desire_id: this.wish.id,
               remark: this.comment
           })
            .catch(err => {
                if (err.code == 20003) {
                    this.showSnack("没有许愿次数了")
                } else {
                    this.showSnack(err.msg)
                }
                
            })
           if (res) {
               this.$emit('wishComplete-confirm')
           }
       }
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    width: 91.76vw;
    margin: 0 auto;
    margin-top: 12vw;
    min-height: 61.11vw;
    background-image: url("../../assets/modal/complete.png");
    background-size: 100% 100%;
    overflow: hidden;
    .content {
        margin: 16vw auto 0;
        width: 66%;
        text-align: center;
        min-height: 24vw;
        font-size: 20px;
    }
    .button-wrapper {
        display: flex;
        justify-content: center;
         align-items: center;
    }
    .button {
        width: 24.63vw;
        margin: 2vw 2vw;
        display: block;
        flex-shrink: 0;
    }
}

</style>